import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchData } from "../../Assets/API/apiservices";
import moment from "moment";
import { ORGANIZATION_ID, SUB_ORGANIZATION_ID } from "../../Config/Config";

const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {
  const [activitiesData, setActivitiesData] = useState([]);
  const [yearsData, setYearsData] = useState([]);
  const [activityId, setActivityId] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const getActivities = async () => {
      setLoading(true);
      try {
        if (activityId) {
          const response = await fetchData(`webpages/${activityId}?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`);
          setActivitiesData(response);
          const years = response.reduce((acc, item) => {
            const year = moment(item.date).year();
            if (!acc.includes(year)) acc.push(year);
            return acc;
          }, []);
          setYearsData(years);
        } else {
          console.error("Activity ID is null");
        }
      } catch (error) {
        console.error("Error fetching activities:", error);
      } finally {
        setLoading(false);
      }
    };
  
    getActivities();
  }, [activityId]);
  

  return (
    <ActivityContext.Provider value={{ activitiesData, yearsData, setActivitiesData, setActivityId, loading }}>
      {children}
    </ActivityContext.Provider>
  );
};


export const useActivity = () => useContext(ActivityContext);
